<!-- IT资产维修流程 -->
<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item' :template-data='templateData'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>
		<Button class="submit-process" v-on:click='submit' v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
		<Button class="submit-process" v-on:click='refuse' v-bind:loading="formLoading" size="large" type="primary"> 驳回
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue';
	import wx from 'weixin-js-sdk'
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from '../api/jssdk.js';
	import {
		getTemplateInfo,
		submitProcess,
		getFlowTemplate,
		sendMessage,
		GetPendingProcessById
	} from '@/api/approval'

	import {
		getRelation
	} from '@/api/employee'
	import {
		getDepartmentRelationByName,
		GetDepartmentByDepId,
		getDepartmentInfo,
		getDepartmentRelationById
	} from '@/api/department'
	import {
		getDepartPrincipal
	} from '@/api/employee'
	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	const sendMessagetTemplate = {
	  title: null,
	  url: null,
	  toUser: [],
	  desc: null,
	  template: null,
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				applyTemplateData: null,
				flowId:null,
				sendMessageData: Object.assign({},sendMessagetTemplate)
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.flowId = this.$route.query.flowId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			stringUtils.setAddIsShow(true);
		},
		methods: { //方法
			
			clickChoose: async function(dataVal, name) {
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["user"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var user = res.result.userList[0];
						dataVal.Values.push([user.id, user.name]);
						dataVal.Value = user.name;
					}
				})
			},
			getFlowTemplateInfo: async function() {
				if (this.flowId == null || this.flowId == undefined || this.flowId.length <= 0) {
					return;
				}
				await getFlowTemplate(this.flowId).then(response => {
					this.applyTemplateData = response.Body;
				});
			},
			getTemplate: async function() {
				await GetPendingProcessById(this.flowId).then(response =>{
					if(response.Body==null){
						this.Message({
							message: '该流程已经处理完成',
							type: 'success',
							duration: 3 * 1000
						});
						setTimeout(() => {
							this.$router.push("/Pricing");
						}, 1000)
						return;
					}
				})
				this.listLoading = true;
				var that = this;
				var title = this.logInfo.fullName;
				var jobLevel = this.logInfo.JobLevel;
				var departFullName = "";
				var DeptId = "";
				await this.getFlowTemplateInfo();
				if (that.applyTemplateData != null) {
					var departId = that.applyTemplateData.TemplateContent.Controls.filter(t => {
						return t.Property.Title[0].Text == "申请部门"
					})[0].Values[0][0];
					getDepartmentInfo(departId).then(async res => {
						departFullName = res.Body.FullName;
						DeptId = res.Body.DeptId;
					});
					getTemplateInfo(this.templateId).then(async response => {
						var controls = response.Body;
						controls.TemplateContent.Controls.forEach(async (item, index) => {
							var departs = this.logInfo.fullName.split("/");

							if (this.applyTemplateData != null) {
								var data = this.applyTemplateData.TemplateContent.Controls.filter(t => {
									return t.Property.Title[0].Text == item.Property.Title[0].Text
								});
								if (item.Property.Title[0].Text == "维修申请人") {
									var dataUser = that.applyTemplateData.TemplateContent.Controls.filter(t => {
										return t.Property.Title[0].Text == "人员"
									})[0].Value;
									var dataUserNo = that.applyTemplateData.TemplateContent.Controls.filter(t => {
										return t.Property.Title[0].Text == "工号"
									})[0].Value;
									if (dataUser != null) {
										item.Value = dataUser;
										item.Values = [
											[dataUserNo, dataUser]
										]
									}
								}
								if (item.Property.Title[0].Text == "核价人员") {
									item.Value = "雷艳";
									item.Disable = true;
								}
								if (item.Property.Title[0].Text == "费用分摊部门") {
									item.Disable = true;
									item.Values = data[0].Values;
									item.Value = data[0].Value;
								}
								if (item.Property.Title[0].Text == "核价人工号") {
									item.Value = "SC18008706";
									item.Disable = true;
								}
								if (item.Property.Title[0].Text == "申请部门") {
									if (data != null) {
										controls.TemplateContent.Controls.forEach(async (dataProcess) => {
											if (dataProcess.Property.Title[0].Text == "申请流程部门") {
												dataProcess.IsShow = false;
												if (departFullName.indexOf("华西区") > -1) {
													dataProcess.Value = "option-1602580683468";
												}
												if (departFullName.indexOf("华西区/四川中原物业顾问有限公司/非营业部") > -1) {
													dataProcess.Value = "option-1602580687899";
												}
												if (departFullName.indexOf("房友圈") > -1) {
													dataProcess.Value = "option-1602580668771";
												}
												if (departFullName.indexOf("住宅部") > -1) {
													dataProcess.Value = "option-1602580653565";
												}
												if (departFullName.indexOf("工商铺商业运营中心") > -1) {
													dataProcess.Value = "option-1602580653566";
												}
												if (departFullName.indexOf("二级市场营运中心") > -1 || departFullName.indexOf("代理") > -1) {
													dataProcess.Value = "option-1602580673427";
												}
												if (departFullName.indexOf("按揭金融服务中心") > -1) {
													dataProcess.Value = "option-1602580677915";
												}
												if (departFullName.indexOf("原友信") > -1) {
													dataProcess.Value = "option-1602580693795";
												}


											}
										});
									}
								}
								if (item.Property.Title[0].Text == "请选择审批流程") {
									item.IsShow = false;
									if (data != null) {
										item.Values = data[0].Values;
										item.Value = data[0].Value;
									}
								}
								if (item.Property.Title[0].Text == "行政主任") {
									item.IsShow = false;
									item.Values = [];
									await getDepartmentRelationByName(departFullName, false).then(res => {
										if (res.Body != null) {
											res.Body[0].Nodes.forEach((depData) => {
												if (depData.Items != null) {
													depData.Items.forEach((userData) => {
														if (userData.PositionName.indexOf("行政主任") > -1) {
															var insertDat = [userData.EmpNo, userData.EmpName]
															item.Values.push(insertDat);
														}
													})
												}
											});
										} else {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
										if (item.Values == null || item.Values.length == 0) {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
									});
								}
								if (item.Property.Title[0].Text == "大战区总经理") {
									item.IsShow = false;
									item.Values = [];
									await getDepartmentRelationByName(departFullName, false).then(res => {
										if (res.Body != null) {
											res.Body[0].Nodes.forEach((depData) => {
												if (depData.Items != null) {
													depData.Items.forEach((userData) => {
														if (userData.PositionName == "总经理") {
															var insertDat = [userData.EmpNo, userData.EmpName]
															item.Values.push(insertDat);
														}
													})
												}
											});
										} else {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
										if (item.Values == null || item.Values.length == 0) {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
									});
								}
								if (item.Property.Title[0].Text == "小战区区董") {
									item.IsShow = false;
									item.Values = [];
									await getDepartmentRelationByName(departFullName, true).then(res => {
										if (res.Body != null) {
											res.Body[0].Nodes.forEach((depData) => {
												if (depData.Items != null) {
													depData.Items.forEach((userData) => {
														if (userData.PositionName.indexOf("区域董事") > -1) {
															var insertDat = [userData.EmpNo, userData.EmpName]
															item.Values.push(insertDat);
														}
													})
												}
											});
										} else {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
										if (item.Values == null || item.Values.length == 0) {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
									});
								}
								if (item.Property.Title[0].Text == "大战区区董") {
									item.IsShow = false;
									item.Values = [];
									await getDepartmentRelationByName(departFullName, true).then(res => {
										if (res.Body != null) {
											res.Body[0].Nodes.forEach((depData) => {
												if (depData.Items != null) {
													depData.Items.forEach((userData) => {
														if (userData.PositionName.indexOf("大区董事") > -1) {
															var insertDat = [userData.EmpNo, userData.EmpName]
															item.Values.push(insertDat);
														}
													})
												}
											});
										} else {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
										if (item.Values == null || item.Values.length == 0) {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
									});
								}
								if (item.Property.Title[0].Text == "经理/总监") {
									item.IsShow = false;
									item.Values = [];
									if (departFullName == "华西区/藤云/联动拓展部") {
										var insertDat = ["SC18004712", "张晓林"]
										item.Values.push(insertDat);
									} else {
										await getDepartmentRelationByName(departFullName, false).then(res => {
											if (res.Body != null) {
												for (var i = 0; i < res.Body.length; i++) {
													res.Body[i].Nodes.forEach((depData) => {
														if (depData.Items != null) {
															depData.Items.forEach((userData) => {
																if (userData.PositionName.indexOf("总监") > -1) {
																	if (item.Values == null || item.Values.length == 0) {
																		var insertDat = [userData.EmpNo, userData.EmpName]
																		item.Values.push(insertDat);
																		return;
																	}
																}
															})
														}
													});
													if (item.Values.length == 0) {
														res.Body[i].Nodes.forEach((depData) => {
															if (depData.Items != null) {
																depData.Items.forEach((userData) => {
																	if (userData.PositionName.indexOf("经理") > -1 && !(userData.PositionName.indexOf("总经理") >
																			-1)) {
																		if (item.Values == null || item.Values.length == 0) {
																			var insertDat = [userData.EmpNo, userData.EmpName]
																			item.Values.push(insertDat);
																			return;
																		}
																	}
																})
															}
														});
													}
												}
											} else {
												item.Values = [
													["SC24000029", "钟志斌"]
												]
											}
											if (item.Values == null || item.Values.length == 0) {
												item.Values = [
													["SC24000029", "钟志斌"]
												]
											}
										});
									}
								}
								if (item.Property.Title[0].Text == "总经理/副总经理") {
									item.IsShow = false;
									item.Values = [];
									await getDepartmentRelationByName(departFullName, false).then(res => {
										if (res.Body != null) {
											console.log(res.Body);
											for (var i = 0; i < res.Body.length; i++) {
												res.Body[i].Nodes.forEach((depData) => {
													if (depData.Items != null) {
														depData.Items.forEach((userData) => {
															if (userData.PositionName.indexOf("总经理") > -1) {
																if(userData.PositionName != "营运中心总经理" && userData.PositionName != "地产代理总经理"){
																	if (item.Values == null || item.Values.length == 0) {
																		var insertDat = [userData.EmpNo, userData.EmpName]
																		item.Values.push(insertDat);
																		return;
																	}
																}
															}
														})
													}
												});
												if (item.Values.length == 0) {
													res.Body[i].Nodes.forEach((depData) => {
														if (depData.Items != null) {
															depData.Items.forEach((userData) => {
																if (userData.PositionName.indexOf("副总经理") > -1) {
																	if (item.Values == null || item.Values.length == 0) {
																		var insertDat = [userData.EmpNo, userData.EmpName]
																		item.Values.push(insertDat);
																		return;
																	}
																}
															})
														}
													});
												}
											}
										} else {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
										if (item.Values == null || item.Values.length == 0) {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
									});
								}
								if (item.Property.Title[0].Text == "总经理") {
									item.IsShow = false;
									item.Values = [];
									await getDepartmentRelationByName(departFullName, false).then(res => {
										if (res.Body != null) {
											res.Body[0].Nodes.forEach((depData) => {
												if (depData.Items != null) {
													depData.Items.forEach((userData) => {
														if (userData.PositionName.indexOf("经理") > -1 && !(userData.PositionName.indexOf("总经理") >
																-1)) {
															if (item.Values == null || item.Values.length == 0) {
																var insertDat = [userData.EmpNo, userData.EmpName]
																item.Values.push(insertDat);
																return;
															}
														}
													})
												}
											});
										} else {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
										if (item.Values == null || item.Values.length == 0) {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
									});
								}
								if(item.Property.Title[0].Text == "部门总经理/总监"){
									item.IsShow = false;
									item.Values = [];
									await getDepartmentRelationByName(departFullName, false).then(res => {
										if (res.Body != null) {
											for (var i = 0; i < res.Body.length; i++) {
												res.Body[i].Nodes.forEach((depData) => {
													if (depData.Items != null) {
														depData.Items.forEach((userData) => {
															if (userData.PositionName.indexOf("总经理") > -1) {
																if (item.Values == null || item.Values.length == 0) {
																	var insertDat = [userData.EmpNo, userData.EmpName]
																	item.Values.push(insertDat);
																	return;
																}
															}
														})
													}
												});
												if (item.Values.length == 0) {
													res.Body[i].Nodes.forEach((depData) => {
														if (depData.Items != null) {
															depData.Items.forEach((userData) => {
																if (userData.PositionName.indexOf("总监") >-1) {
																	if (item.Values == null || item.Values.length == 0) {
																		var insertDat = [userData.EmpNo, userData.EmpName]
																		item.Values.push(insertDat);
																		return;
																	}
																}
															})
														}
													});
												}
											}
										} else {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
										if (item.Values == null || item.Values.length == 0) {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
									});
								}
								if (item.Property.Title[0].Text == "部门经理") {
									item.IsShow = false;
									item.Values = [];
									await getDepartmentRelationByName(departFullName, false).then(res => {
										if (res.Body != null) {
											res.Body[0].Nodes.forEach((depData) => {
												if (depData.Items != null) {
													depData.Items.forEach((userData) => {
														if (userData.PositionName.indexOf("经理") > -1 && !(userData.PositionName.indexOf("总经理") >-1)) {
															var insertDat = [userData.EmpNo, userData.EmpName]
															item.Values.push(insertDat);
														}
													})
												}
											});
										} else {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
										if (item.Values == null || item.Values.length == 0) {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
									});
								}
								if (item.Property.Title[0].Text == "非营业逐级审批") {
									item.Values = [];
									item.IsShow = false;
									await getDepartmentRelationById(DeptId).then(res => {
										if (res.Body != null && res.Body.length > 0) {
											for(var i = 0;i < res.Body[0].Nodes.length;i++){
												var depData = res.Body[0].Nodes[i];
												if(depData.DeptName == "非营业部"){
													break;
												}
												if (depData.Items != null) {
													depData.Items.sort(function(a,b){
														return a.JobLevel - b.JobLevel
													})
													depData.Items.forEach((userData) => {
														var insertDat = [userData.EmpNo, userData.EmpName]
														item.Values.push(insertDat);
													})
												}
											}
											
										} else {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
										if (item.Values == null || item.Values.length == 0) {
											item.Values = [
												["SC24000029", "钟志斌"]
											]
										}
									});
								}
								if (item.Property.Title[0].Text == "供货状态") {
									item.IsShow = false;
									item.Values = [];
								}
								if (item.Property.Title[0].Text == "申请部门") {
									item.Values = data[0].Values;
									item.Value = data[0].Value;
									item.Disable = true;
								}
								if (item.Property.Title[0].Text == "申请原因") {
									item.Disable = true;
									item.Values = data[0].Values;
									item.Value = data[0].Value;
								}
								if (item.Property.Title[0].Text == "信息部门验收") {
									item.IsShow = false;
									item.Values = [];
									item.addIsShow = true;
								}
								if (item.Property.Title[0].Text == "实付金额") {
									item.IsShow = false;
									item.Values = [];
								}
								if (item.Property.Title[0].Text == "合计") {
									item.Disable = true;
								}
								
								if (item.Property.Title[0].Text.indexOf("信息中心核价") > -1) {
									item.addIsShow = true;
								}
								// if (item.Property.Title[0].Text.indexOf("信息中心技术鉴定") > -1) {
								// 	item.addIsShow = false;
								// 	item.Config.Table.Children.forEach(authenticate => {
								// 		authenticate.Disable = true;
								// 	});
								// }
							}
						});
						var controlsLength = controls.TemplateContent.Controls.length;
						// for (var j = 0; j < controlsLength; j++) {
						// 	var controlsData = controls.TemplateContent.Controls[j];
						// 	var departs = this.logInfo.fullName.split("/");
						// 	if (this.applyTemplateData != null) {
						// 		var data = this.applyTemplateData.TemplateContent.Controls.filter(t => {
						// 			return t.Property.Title[0].Text == controlsData.Property.Title[0].Text
						// 		});
						// 		if (controlsData.Property.Title[0].Text == "申请内容") {
						// 			controlsData.addIsShow = false;
						// 			var i = 1;
						// 			this.applyTemplateData.TemplateContent.Controls.forEach(async (applyData) => {
						// 				if (applyData.Property.Title[0].Text.indexOf("申请内容") > -1) {
						// 					if (applyData.Property.Title[0].Text != "申请内容") {
						// 						applyData.Config.Table.Children.forEach(childItem => {
						// 							childItem.Disable = true;
						// 							if (childItem.Property.Title[0].Text == "类型选择") {
						// 								childItem.Config.Selector.Options[0].Key = "option-1602654697338";
						// 								childItem.Config.Selector.Options[1].Key = "option-1602654697339";
						// 							}
						// 						})
						// 						var AddTable = JSON.stringify(controlsData);
						// 						AddTable = JSON.parse(AddTable);
						// 						AddTable.Property.Title[0].Text = AddTable.Property.Title[0].Text + i;
						// 						AddTable.Property.Id = "Table-1602654202631";
						// 						// AddTable.Property.Id = "Table-" + this.guid();
						// 						AddTable.addIsShow = false;
						// 						AddTable.Config.Table.Children.forEach(forDisable => {
						// 							forDisable.Disable = true;
						// 						});
						// 						controls.TemplateContent.Controls.splice(j + i, 0, AddTable);
						// 						i++;
						// 					}
						// 				}
						// 			});
						// 			controlsData.Config.Table.Children.forEach(childItem => {
						// 				childItem.Disable = true;
						// 			})
						// 			break;
						// 		}
						// 	}
						// }
						this.templateData = this.assignControl(controls, this.logInfo);
						this.templateData = await this.assignControlBySpNo(controls, null, this.flowId);
						this.listLoading = false;
					});
				}
			},
			getTextVal() {},
			getSelectorVal(val, name) {},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				var controlInfo = datas;
				var that = this;
				var i = 0;
				var j = 0;
				var a = 0;
				var reg = /[\u4e00-\u9fa5]/g;
				var names = val.match(reg).join("");
				var controls = that.templateData.TemplateContent.Controls;
				var name = val;
				if (type == "delete") {
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Id == controlInfo.Id) {
							controls.splice(i, 1);
							break;
						}
					}
					var count = 0;
					var control = null;
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text.indexOf(names) >= 0) {
							control = controls[i];
							count++;
						}
					}
					that.$set(control, 'deleteIsShow', false);
					var controlYanshou = null;
					var controlYanshouId = "";
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text.indexOf("信息部门验收" + val.slice(6)) >= 0) {
							controlYanshou = controls[i];
							controlYanshouId = controls[i].Id;
							count++;
						}
					}
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Id == controlYanshouId) {
							controls.splice(i, 1);
							break;
						}
					}
				} else {
					that.$set(controlInfo, 'deleteIsShow', true);
					controlInfo.Id = "Table-" + this.guid();
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text == val) {
							var control = JSON.stringify(controls[i]);
							control = JSON.parse(control);
							control.Id = "Table-" + this.guid();
							var children = control.Config.Table.Children;
							var table = controls.filter(item => {
								return item.Property.Title[0].Text == "信息部门验收"
							})[0];
							table.Id = "Table-" + this.guid();
							table.Id = "Table-" + this.guid();
							var AddTable = JSON.stringify(table);
							AddTable = JSON.parse(AddTable);
							controls.splice(controls.indexOf(table) + 1, 0, AddTable);

							for (var y = 0; y < children.length; y++) {
								children[y].Value = null;
								children[y].Values = null;
							}
							controls.splice(i + 1, 0, control);
							break;
						}
					}

				}

				for (i = 0; i < controls.length; i++) {
					if (controls[i].Property.Title[0].Text.indexOf(names) >= 0) {
						if (j == 0) {
							controls[i].Property.Title[0].Text = names;
						} else {
							controls[i].Property.Title[0].Text = names + j;
						}
						j++;
					}
				}
				if (names.indexOf("信息中心核价") > -1) {
					j = 0;
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text.indexOf("信息部门验收") >= 0) {
							if (j == 0) {
								controls[i].Property.Title[0].Text = "信息部门验收";
							} else {
								controls[i].Property.Title[0].Text = "信息部门验收" + j;
							}
							j++;
						}
					}
				}
			},
			S4() {
				return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
			},
			guid() {
				return (this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() +
					this.S4());
			},
			refuse() {
				this.sendMessageData.template = this.templateData;
				this.sendMessageData.title = "IT资产维修";
				var toUser = this.templateData.TemplateContent.Controls.filter(t => {
								return t.Property.Title[0].Text == "维修申请人"
							})[0].Values[0][0];
				this.sendMessageData.toUser = [toUser];
				this.sendMessageData.desc = "驳回人员：" + this.logInfo.EmpName;
				this.sendMessageData.url = document.location.hostname +
					"/ITAssetMaintenanceA?templateId=3TmBHRzNERAhDvJRCnz7mTniazGWUbEXgEDodAUP&flowId=" + this.flowId;
				//提交
				sendMessage(this.templateId, this.logInfo.EmpNo, this.spNo, this.sendMessageData, 2,"",this.flowId).then(response => {
					this.Message({
						message: '驳回成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {});
			},
			submit() {

				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;
				this.listLoading = true;

				var controls = this.templateData.TemplateContent.Controls;
				var applyNo = "";
				controls.forEach((item) => {
					if(item.Property.Title[0].Text.indexOf("维修申请人") > -1){
						applyNo = item.Values[0][0];
					}
					if (item.Property.Title[0].Text.indexOf("信息中心核价") > -1) {
						controls.forEach((appraisal) => {
							if (appraisal.Property.Title[0].Text.indexOf("信息部门验收") > -1) {
								if (item.Property.Title[0].Text.slice(6) == appraisal.Property.Title[0].Text.slice(6)) {
									for (var i = 0; i < appraisal.Config.Table.Children.length; i++) {
										if (appraisal.Config.Table.Children[i].Property.Title[0].Text == "物品名称") {
											appraisal.Config.Table.Children[i].Value = item.Config.Table.Children.filter(t => {
												return t.Property.Title[0].Text == "物品名称"
											})[0].Value;
											continue;
										}
										if (appraisal.Config.Table.Children[i].Property.Title[0].Text == "单位") {
											appraisal.Config.Table.Children[i].Value = item.Config.Table.Children.filter(t => {
												return t.Property.Title[0].Text == "单位"
											})[0].Value;
											continue;
										}
										if (appraisal.Config.Table.Children[i].Property.Title[0].Text == "验收数量") {
											appraisal.Config.Table.Children[i].Value = item.Config.Table.Children.filter(t => {
												return t.Property.Title[0].Text == "数量"
											})[0].Value;
											continue;
										}
										if (appraisal.Config.Table.Children[i].Property.Title[0].Text == "验收单价") {
											appraisal.Config.Table.Children[i].Value = item.Config.Table.Children.filter(t => {
												return t.Property.Title[0].Text == "预计单价"
											})[0].Value;
											continue;
										}
										if (appraisal.Config.Table.Children[i].Property.Title[0].Text == "小计") {
											appraisal.Config.Table.Children[i].Value = item.Config.Table.Children.filter(t => {
												return t.Property.Title[0].Text == "预计金额"
											})[0].Value;
											continue;
										}
									}
								}
							}
						});
					}
					if (item.Property.Title[0].Text == "实付金额") {
						item.IsShow = true;
						item.Value = controls.filter(t => {
							return t.Property.Title[0].Text == "合计"
						})[0].Value;
					}

				});
				console.log(JSON.stringify(this.templateData.TemplateContent.Controls));
				//提交
				submitProcess(this.templateId, applyNo, this.spNo, this.templateData,this.flowId).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.listLoading = false;
					var controls = this.templateData.TemplateContent.Controls;
					controls.forEach((item) => {
						if (item.Property.Title[0].Text == "实付金额") {
							item.IsShow = true;
							item.Value = controls.filter(t => {
								return t.Property.Title[0].Text == "合计"
							})[0].Value;
						}
					});
				});
			}
		},
		watch: {
			relationList(val, oldVal) {
				if (oldVal == null) {
					this.getTemplate();
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
